import { Button, styled } from "@mui/material";
import { useEffect, useState } from "react";

import { useStore } from "@/app/model/RootStoreContext";

import styles from "./styles.module.css";

const StyledTextButton = styled(Button)({
  fontFamily: "inherit",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "18px",
  letterSpacing: "0.2px",
  textTransform: "revert",
});

interface IProps {
  title?: string;
  description?: string;
  cancelText?: string;
  confirmText?: string;
  onCancel?: () => void;
  onConfirm?: () => Promise<void>;
}

const Confirmation = ({
  title,
  description,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
}: IProps) => {
  const { confirmationModalStore } = useStore();

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm?.();
      // eslint-disable-next-line no-useless-catch
    } catch (err) {
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (confirmationModalStore.isOpen) {
        confirmationModalStore.reset();
      }
    };
  }, [confirmationModalStore]);

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
      <div className={styles["buttons-wrapper"]}>
        {onCancel && (
          <StyledTextButton variant="text" color="custom" onClick={onCancel}>
            {cancelText}
          </StyledTextButton>
        )}
        {onConfirm && (
          <StyledTextButton
            variant="text"
            loading={isLoading}
            onClick={handleConfirm}
          >
            {confirmText}
          </StyledTextButton>
        )}
      </div>
    </div>
  );
};

export default Confirmation;
